import api from '../../../services/api';

/**
 * Endpoints do M7 com o nome do domínio.
 *
 * ⚠️ Repasse fino para `services/api.js`, que é onde os endpoints do projeto
 * moram. Existe só para as telas do repack lerem `SplitLpn(...)` em vez de
 * `api.splitLpn(...)` — nenhuma regra, nenhum transporte próprio.
 *
 * A PRÉVIA é o mesmo motor da execução: nenhuma conta de saldo acontece no
 * navegador. Quem soma é o servidor, nos dois caminhos — senão a tela poderia
 * prometer um saldo que o banco não vai gravar.
 */
export function PreviewRepack(body) {
    return api.previewRepack(body);
}

/** SPLIT (1 → N). O LPN de origem NÃO morre por ser desmembrado (§6.2). */
export function SplitLpn(body) {
    return api.splitLpn(body);
}

/** MERGE / transferência (N → 1). N = 1 é a transferência. */
export function MergeLpns(body) {
    return api.mergeLpns(body);
}

/**
 * PICKING FRACIONADO — **não gera LPN**. Credita em UM de dois destinos:
 * consumo de OP (bancada do M6) ou volume de expedição. Sem um dos dois o
 * backend recusa com 409 — o saldo não pode sair do sistema (§3).
 */
export function PickFractional(body) {
    return api.pickFractional(body);
}

/**
 * O seletor em ordem FIFO (§6.2): `fifo_rank` 1 = o mais antigo. A ordem é a
 * informação — nada aqui bloqueia nada.
 */
export function ListRepackCandidates(params = {}) {
    return api.getRepackCandidates(params);
}

/** Volumes de expedição — o TERCEIRO lugar do invariante (§3). */
export function ListShipmentVolumes(params = {}) {
    return api.getShipmentVolumes(params);
}

/** Volume + conteúdo (o saldo que vive dentro dele). */
export function GetShipmentVolume(id) {
    return api.getShipmentVolume(id);
}
